import styled from "styled-components";

const Table = styled.table`
  align-self: center;
  width: 100%;

  ${({ overflow }) => overflow && `overflow: scroll; display: block;`}
`;
export default Table;
